export default function () {
  const widgetName = 'contactCardsFeature';
  const widgetOpts = contactCardsFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function addClass() {
        $(`#${widgetName} .card-widget-item`).each(function () {
          $(this).find(".moreButton").addClass("button");
          $(this).find(".moreButton").removeClass("moreButton");
          $(this).find(".button").attr("target","");
        })
      }
      addClass()
    },

    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 3,
    moreButton: {
      visible: true,
      text: 'More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true
  });
}